import * as React from "react";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import User from "../../../model/user/User";
import "../../v5/table/workspaceCardList.scss";

interface ComponentProps {
	/**
	 * Partner brand ID.
	 */
	partnerBrandId: string
	/**
	 * Row click callback
	 */
	onRowClick: (user: User) => void
}

interface ReduxProps {
	/**
	 * Partner brand users.
	 */
	users: User[];
}

type Props = ComponentProps & ReduxProps;

interface State {
	/**
	 * Indicates if the screen is a phone's, where users show as cards rather than as a table.
	 */
	isPhone: boolean;
}

class PartnerBrandUsersTable extends React.PureComponent<Props, State> {
	phoneQuery: MediaQueryList | null = window.matchMedia ? window.matchMedia("(max-width: 640px)") : null;

	constructor(props: Props) {
		super(props);
		this.state = {isPhone: !!this.phoneQuery && this.phoneQuery.matches};
	}

	componentDidMount() {
		if (this.phoneQuery) {
			this.phoneQuery.addListener(this.onPhoneChange);
		}
	}

	componentWillUnmount() {
		if (this.phoneQuery) {
			this.phoneQuery.removeListener(this.onPhoneChange);
		}
	}

	onPhoneChange = (query: MediaQueryList) => this.setState({isPhone: query.matches});

	/**
	 * A card per user on a phone, as on the users list.
	 */
	private renderCards() {
		return (
			<ul className={"c-workspace-cards"}>
				{this.props.users.map(user =>
					<li key={user.id}>
						<button type={"button"}
								className={"c-workspace-cards_card is-single-column"}
								onClick={() => this.props.onRowClick(user)}>
							<span className={"c-workspace-cards_main"}>
								<span className={"c-workspace-cards_title"}>
									{`${user.data.firstName} ${user.data.lastName}`}
								</span>
								<span className={"c-workspace-cards_line"}>{user.data.username}</span>
							</span>
						</button>
					</li>
				)}
			</ul>
		);
	}

	render() {
		return (
			<div style={{paddingBottom: "30px"}}>
				<label className={"m-form-group_label"}>
					Users
				</label>
				{this.state.isPhone ? this.renderCards() :
				<div>
					<DataGrid hasHover={true} hasPointer={true}>
						<thead>
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Email</th>
						</tr>
						</thead>
						<tbody>
						{this.props.users.map((user) =>
							<tr key={user.id}
								onClick={() => this.props.onRowClick(user)}>
								<td>{user.data.firstName}</td>
								<td>{user.data.lastName}</td>
								<td>{user.data.username}</td>
							</tr>
						)}
						</tbody>
					</DataGrid>
				</div>}
			</div>
		);
	}
}

function mapStateToProps(state: RootState, props: Props) {
	return {
		users: state.user.users.getOrElse([]).filter(user => user.data.partnerBrandId.getOrElse('') === props.partnerBrandId)
	}
}

export default connect<ReduxProps, null, ComponentProps>(mapStateToProps)(PartnerBrandUsersTable);